import styled from "styled-components";
import { IconButton } from "@8x8/oxygen-icon-button";

export const EmailDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 25px;
  width: 100%;
`;

export const EmailDetailsSubContainer = styled.div`
  grid-column: ${(props) => props.column ?? "1"};
  grid-row: ${(props) => props.row ?? "1"};
`;

export const VersionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ThumbnailButtonWrapper = styled.div`
  width: fit-content;
  align-content: center;
  justify-content: center;
`;

export const ThumbnailButton = styled(IconButton)`
  flex: 2;
`;

export const ThumbnailImageContainer = styled.div`
  margin: 10px;
`;

export const SendButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
